
import { useEditorContext } from "../providers/hekProvider";
import { useState, useEffect, useRef, useMemo } from "react";


import PageComp from "./PageComp";
import MagazinProperties from "./MagazinProperties";
import Sounds from "./Sounds";
import SosialMadia from "./SosialMadia";
import { useAlert } from "react-alert";
import {
    SlideAdd, SlideUpdate, PageDelete, PagePreviewOnOff, PagePropertiesUpdate,
    PageFrontTitleOnOff, PageShowMainOnOff, PageImageUpload,
    GlobalUrl, GetPageByID, AddShortText, UpdateSoundPage,
    DeleteSoundOnPage, UpdatePageName, UpdateSubTitle, UpdateYazar, GetSlideList, SlideDelete, GetAllPageByIssueID, SoundOwnerUpdate
} from "../db/db";
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import { durationTime, getDuration } from "../db/soundProcess";
import Slider from "./Slider";
import { Form, Col, Row, Button, Modal, ProgressBar } from "react-bootstrap";
import { FaTrashAlt } from 'react-icons/fa';

const EditorTest = () => {
    const { editor, pages, myEditor, MagazineID, selectedPageProps, setselectedPageProps, pageSlide, ReloadSlide, showDetail, setshowDetail, setPages } = useEditorContext();
    const [hekEditor, setHekEditor] = useState();
    const QIssueIDData = (window.location.search.split("?MID=")[1] != undefined) ? window.location.search.split("?MID=")[1] : window.location.pathname.split('/')[1]
    const [prevChek, setprevChek] = useState(0);
    const [frontTitleChek, setfrontTitleChek] = useState(0);
    const [showMainChek, setshowMainChek] = useState(0);
    const [ShortText, setShortText] = useState()//(selectedPageProps.shortText)
    const [showShortText, setShowShortText] = useState("none")
    const [QIssueID, setQIssueID] = useState(QIssueIDData)
    const [ModalProp, setModalProp] = useState({ title: "title", message: "messaj" })
    const [show, setShow] = useState(false);
    const [pageName, setPageName] = useState()//(selectedPageProps.name)
    const [subTitle, setSubTitle] = useState()//(selectedPageProps.subtitle)
    const [yazar, setYazar] = useState()//(selectedPageProps.author)
    const [aktifSlide, setAktifSlide] = useState()
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [Pcount, setPcount] = useState(10)
    const [nowPage, setNowPage] = useState(selectedPageProps)







    useEffect(() => {
        console.log("auth")
        if (sessionStorage.getItem("Login") != "OK") {
            // window.location.href="https://panel.edergilik.com/login"
        }

        // console.log("rawdatanedir", editor.getComponents().length)
        //  if (editor.getComponents().length <= 0) {
        if (selectedPageProps.rawData != undefined) {
            // Transform old URLs to new domain
            let transformedRawData = selectedPageProps.rawData.replace(/panel\.edergilik\.com/g, 'edergipanel.semerkanddijital.com.tr');
            editor.setComponents(JSON.parse(transformedRawData));
        }
        if (selectedPageProps.rawCss != undefined) {
            let transformedRawCss = selectedPageProps.rawCss.replace(/panel\.edergilik\.com/g, 'edergipanel.semerkanddijital.com.tr');
            editor.setStyle(transformedRawCss);
        } else {
            editor.setStyle(selectedPageProps.rawCss);
        }
        editor.PageID = selectedPageProps.id
        editor.PageName = selectedPageProps.name
        editor.IssueID = QIssueID
        //setNowPage(selectedPageProps)
        // }
    });

    const ModalOpen = (ModalTitle, ModalMessage) => {
        setModalProp({
            title: ModalTitle,
            message: ModalMessage
        })
        setShow(true)
    }


    const myAlert = useAlert();
    const inputRef = useRef(null);




    return (

        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{ModalProp.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {ModalProp.message}
                    <ProgressBar striped variant="danger" now={Pcount} /></Modal.Body>

            </Modal>

            <div id="PageListOrder" className="gjs-pn-views-container gjs-blocks-cs gjs-one-bg gjs-two-color"
                style={{

                    "margin": "0px",
                    "padding": "0px",
                    "zIndex": "999",
                    "position": "absolute",
                    "top": "40px",
                    "right": "0px",
                    "display": "none",
                    "overflow": "auto",

                    "overflowX": "hidden",
                    //"overflow-y": "scroll",

                    //"maxWidth":"280px"

                }}>

                {
                    pages.map((data, index) => {
                        console.log("Tum Sayfalar Geldi" + data)
                    })
                }

                <PageComp hekEditor={hekEditor} />




            </div>

            <div id="MagazinPropertiesDiv" className="gjs-pn-views-container gjs-blocks-cs gjs-one-bg gjs-two-color"
                style={{

                    "margin": "100px",
                    "padding": "0px",
                    "zIndex": "999",
                    "position": "absolute",
                    "top": "40px",
                    "right": "0px",
                    "display": "none",
                    "overflow": "auto",

                    "overflowX": "hidden",
                    //"overflow-y": "scroll",

                    //"maxWidth":"280px"

                }}>

                <MagazinProperties />
            </div>


            <div id="SoundsDiv" className="gjs-pn-views-container gjs-blocks-cs gjs-one-bg gjs-two-color"
                style={{

                    "margin": "0px",
                    "padding": "0px",
                    "zIndex": "999",
                    "position": "absolute",
                    "top": "40px",
                    "right": "0px",
                    "display": "none",
                    "overflow": "auto",

                    "overflowX": "hidden",
                    //"overflow-y": "scroll",

                    //"maxWidth":"280px"

                }}>

                <Sounds MagazineID={MagazineID} />
            </div>
            <div id="SosialDiv" className="gjs-pn-views-container gjs-blocks-cs gjs-one-bg gjs-two-color"
                style={{

                    "margin": "0px",
                    "padding": "0px",
                    "zIndex": "999",
                    "position": "absolute",
                    "top": "40px",
                    "right": "0px",
                    "display": "none",
                    "overflow": "auto",

                    "overflowX": "hidden",
                    //"overflow-y": "scroll",

                    //"maxWidth":"280px"

                }}>

                <SosialMadia MagazineID={MagazineID} />
            </div>



            {/* Kutu1 */}

            <div id="PropetiesContainer" style={{ "display": showDetail }}>
                <div id="PropHeader" >Sayfa Özellikleri</div>
                <div className="PropItem">
                    <div>
                        <div>Ön İzleme</div>
                        <div>
                            <button onClick={async () => {
                                const setVal = (selectedPageProps.prev === 0) ? 1 : 0;
                                await PagePreviewOnOff(selectedPageProps.id, setVal).then((res) => {
                                    if (res) {
                                        if (setVal) {
                                            myAlert.success("Sayfa Ön İzlemeye Alındı")
                                            setselectedPageProps({ ...selectedPageProps, prev: setVal })
                                        }
                                        else {
                                            myAlert.success("Sayfa Ön İzlemeden Çıkartıldı")
                                            setselectedPageProps({ ...selectedPageProps, prev: setVal })
                                        }
                                    }

                                }).catch((err) => {
                                    myAlert.error("Bir hata oluştu! İşlem Gerçekleştirilemedi " + err)
                                })
                            }}>{(selectedPageProps.prev === 0) ? "Ekle" : "Çıkar"}</button>

                            {/* <input type="checkbox" class="switch"
                                defaultChecked={selectedPageProps.prev}

                                onChange={async (e) => {

                                    await (PagePreviewOnOff(selectedPageProps.id, (e.target.checked) ? 1 : 0)).then((res) => {
                                        if (res) {
                                            if (e.target.checked) {
                                                myAlert.success("Sayfa Ön İzlemeye Alındı")
                                            }
                                            else {
                                                myAlert.success("Sayfa Ön İzlemeden Çıkartıldı")
                                            }
                                        }


                                    }).catch((err) => {
                                        myAlert.error("Bir hata oluştu! İşlem Gerçekleştirilemedi" + err)
                                    })



                                }}

                            /> */}



                        </div></div>

                    <div>
                        <div>Öne Çıkar</div>
                        <div>
                            <button onClick={async () => {
                                const setVal = (selectedPageProps.frontTitle === 0) ? 1 : 0;
                                await PageFrontTitleOnOff(selectedPageProps.id, setVal).then((res) => {
                                    if (res) {
                                        if (setVal) {
                                            myAlert.success("Sayfa öne çıkanlara eklendi")
                                            setselectedPageProps({ ...selectedPageProps, frontTitle: setVal })
                                        }
                                        else {
                                            myAlert.success("Sayfa Öne çıkanlardan çıkartıldı")
                                            setselectedPageProps({ ...selectedPageProps, frontTitle: setVal })
                                        }
                                    }

                                }).catch((err) => {
                                    myAlert.error("Bir hata oluştu! İşlem Gerçekleştirilemedi " + err)
                                })
                            }}>{(selectedPageProps.frontTitle === 0) ? "Ekle" : "Çıkar"}</button>



                        </div>

                    </div>
                    <div>
                        <div>Başyazı</div>
                        <div>
                            <button onClick={async () => {
                                const setVal = (selectedPageProps.showMain === 0) ? 1 : 0;
                                await PageShowMainOnOff(selectedPageProps.id, setVal).then((res) => {
                                    if (res) {
                                        if (setVal) {
                                            myAlert.success("Sayfa başyazıolarak eklendi")
                                            setselectedPageProps({ ...selectedPageProps, showMain: setVal })
                                        }
                                        else {
                                            myAlert.success("Sayfa başyazıdan çıkartıldı")
                                            setselectedPageProps({ ...selectedPageProps, showMain: setVal })
                                        }
                                    }

                                }).catch((err) => {
                                    myAlert.error("Bir hata oluştu! İşlem Gerçekleştirilemedi " + err)
                                })
                            }}>{(selectedPageProps.showMain === 0) ? "Ekle" : "Çıkar"}</button>

                            {/* <input type="checkbox" class="switch"
                                defaultChecked={selectedPageProps.showMain}

                                onChange={async (e) => {

                                    await (PageShowMainOnOff(selectedPageProps.id, (e.target.checked) ? 1 : 0)).then((res) => {
                                        if (res) {
                                            if (e.target.checked) {
                                                myAlert.success("Sayfa başyazıolarak eklendi")
                                                // setShortText("block")
                                            }
                                            else {
                                                myAlert.success("Sayfa başyazıdan çıkartıldı")
                                                //setShortText("none")
                                            }
                                        }

                                    }).catch((err) => { myAlert.error("Bir hata oluştu! İşlem Gerçekleştirilemedi " + err) })



                                }
                                } /> */}



                        </div>

                    </div>


                    <div>




                        <button onClick={async () => {
                            const AlertConfirm = window.confirm(selectedPageProps.name + " Silmek istediğinizden eminmisiniz?");
                            if (AlertConfirm) {
                                const postResult = await PageDelete(selectedPageProps.id).then((res) => {
                                    myAlert.success("Sayfa Silindi")
                                    window.location.reload();
                                }).catch((err) => { myAlert.error("Hata ile karşılaşıldı " + err) })
                            }
                        }}><FaTrashAlt />Sayfayı Sil</button></div>

                    <div>
                        <div>Sayfa Adı</div></div>
                    <div>
                        <div>
                            <input type="text"
                                style={{ "width": "100px" }} defaultValue={selectedPageProps.name}
                                onChange={(e) => {
                                    setPageName(e.target.value)
                                }}
                            ></input><button onClick={async () => {
                                await UpdatePageName(selectedPageProps.id, pageName).then((res) => {
                                    //setselectedPageProps([{...selectedPageProps,name:pageName}])
                                    myAlert.success("Sayfa İsmi Değiştirildi")
                                }).catch((err) => { myAlert.error("İşlem Gerçekleştirilemedi " + err) })

                            }}>Kaydet</button></div>

                    </div>

                    <div>
                        <div>Alt Başlık</div>
                    </div><div>
                        <div><input type="text"
                            style={{ "width": "100px" }} defaultValue={selectedPageProps.subtitle}
                            onChange={(e) => {
                                setSubTitle(e.target.value)
                            }}
                        ></input><button onClick={async () => {
                            await UpdateSubTitle(selectedPageProps.id, subTitle).then((res) => {
                                //setselectedPageProps([{ ...selectedPageProps, subtitle: subTitle }])
                                myAlert.success("Sayfa Alt Başlığı Değiştirildi")
                            }).catch((err) => { myAlert.error("İşlem Gerçekleştirilemedi " + err) })

                        }}>Kaydet</button></div>

                    </div>
                    <div>
                        <div>Yazar</div>
                    </div><div>
                        <div><input type="text"
                            style={{ "width": "100px" }} defaultValue={selectedPageProps.author}
                            onChange={(e) => {
                                setYazar(e.target.value)
                            }}
                        ></input><button onClick={async () => {
                            await UpdateYazar(selectedPageProps.id, yazar).then((res) => {
                                //setselectedPageProps([{ ...selectedPageProps, author: yazar }])
                                myAlert.success("Yazar Bilgisi Değiştirildi")
                            }).catch((err) => { myAlert.error("İşlem Gerçekleştirilemedi " + err) })

                        }}>Kaydet</button></div>

                    </div>



                </div>

                <div id="Kisaca" >
                    <div >Kısa Açıklama</div>
                    <div><textarea style={{ "width": "100%", "height": "50px", "resize": "none" }} defaultValue={(selectedPageProps.shortText == null) ? "" : selectedPageProps.shortText} onChange={(e) => { setShortText(e.target.value) }} ></textarea></div>
                    <div><button onClick={async () => {

                        const ShortTextSave = await AddShortText(selectedPageProps.id, ShortText).then((res) => {
                            myAlert.success("Kısa Yazı Kayıt Edildi")
                        })

                    }}>Kısa Yazıyı Kaydet</button></div>
                </div>
                <div id="SayfaResmi" >
                    <div>Sayfa Resmi</div>
                    <div>
                        <img src={GlobalUrl + "primemags/" + QIssueID + "/" + selectedPageProps.thumbUrl}
                            style={{ "width": "50%" }} /></div>
                    <div><input style={{ "marginTop": "2%" }} type="file" accept="image/*" onChange={
                        async (e) => {



                            const returnThumUrl = await PageImageUpload(e.target.files[0], selectedPageProps.id, QIssueID).then((res) => {
                                setselectedPageProps({
                                    ...selectedPageProps,
                                    thumbUrl: res,
                                    rawData: JSON.stringify(editor.Components.getComponents()),
                                    rawCss: editor.getCss()
                                })
                                console.log("CoverImage", res)
                                myAlert.success("Resim Dosyası İşlendi")
                            }).catch((err) => {
                                myAlert.error("Dosya işlenemnedi " + err)
                            })






                        }} /></div>
                </div>
                <div id="SayfaMuzik" >
                    <div >Sayfa Sesi</div>
                    <div>
                        <audio style={{ "width": "100%", "margin": "5px", "height": "20px" }} src={GlobalUrl + "primemags/" + QIssueID + "/" + selectedPageProps.soundUrl} controls />
                    </div>
                    <div>
                        <input type="file" accept="audio/*" onChange={
                            async (e) => {

                                const dT = await durationTime(e.target.files[0])
                                ModalOpen("Ses Dosyası İşleniyor", "Ses Dosyasının İşlenmesi Biraz Zaman Alabilir...")
                                const pcTime = setInterval(async () => {

                                    setPcount(Pcount + 2)
                                    if (dT != "NaN") {

                                        clearInterval(pcTime)

                                        setShow(false)

                                        await UpdateSoundPage(e.target.files[0], selectedPageProps.id, QIssueID, dT).then((res) => {
                                            setselectedPageProps({
                                                ...selectedPageProps,
                                                soundUrl: res,
                                                rawData: JSON.stringify(editor.Components.getComponents()),
                                                rawCss: editor.getCss()
                                            })

                                            myAlert.success("Ses Dosyası İşlendi ")

                                        }).catch((err) => {
                                            myAlert.error("ses işleme sırasında hata " + err)
                                        })

                                    }

                                }, 1000)








                            }} />
                        <div>
                            <div>
                                <label>Ses Sahibi {selectedPageProps.soundOwner}</label>
                                <input id="SoundOwner" style={{ "margin": "2px" }} type="text" placeholder={selectedPageProps.soundOwner} />
                                <button onClick={async () => {
                                    console.log("Nelervar", selectedPageProps)
                                    await SoundOwnerUpdate(selectedPageProps.id, document.getElementById("SoundOwner").value)
                                        .then((res) => {
                                            setselectedPageProps({
                                                ...selectedPageProps, soundOwner: document.getElementById("SoundOwner").value
                                            })
                                            myAlert.success("Ses Sahibi Güncellendi")
                                        }).catch((err) => { myAlert.error("Ses silinemedi " + err) })
                                }}>Ses Sahibini Güncelle</button>
                                <button style={{ "backgroundColor": "rgba(255,0,0,0.75)", "color": "white", "marginTop": "4%", "marginLeft": "0px" }} onClick={async () => {
                                    await DeleteSoundOnPage(selectedPageProps.id).then((res) => {
                                        setselectedPageProps({ ...selectedPageProps, soundUrl: "" })
                                        myAlert.success("Ses Dosyası Silindi")
                                    }).catch((err) => { myAlert.error("Ses silinemedi " + err) })

                                }}>Sesi Sil</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="SliderContainer" style={{ "display": showDetail }}>
                <div className="TitleHeder"> Slide Gösterlleri</div>
                <div className="ImageItem">


                    <input
                        style={{ display: 'none' }}
                        ref={inputRef}
                        type="file"
                        onChange={
                            async (e) => {

                                const UpdateResult = await SlideUpdate(e.target.files[0], selectedPageProps.id, QIssueID, aktifSlide)
                                    .then(async (result) => {

                                        await ReloadSlide(selectedPageProps.id).then((rres) => {
                                            myAlert.success("Resim Güncellendi")
                                        }).catch((err) => { myAlert.error("İşlem Gerçekleşmedi " + err) })
                                    }).catch((err) => { myAlert.error("işleminiz sırasında hata oluştu " + err) })

                            }
                        }
                    />

                    {
                        pageSlide &&
                        pageSlide.sonuc.map((imgSlide, SlideIndex) => {
                            console.log("gelenslide", imgSlide.imagePath)
                            return (
                                <div className="FlexBoxSlide" >
                                    <div style={{ "backgroundColor": "#fff", "justifyContent": "center" }}>

                                        <img onClick={() => {
                                            setAktifSlide(imgSlide.id)
                                            inputRef.current.click();

                                        }} id={SlideIndex} style={{ "width": "85%" }} src={GlobalUrl + "primemags/" + QIssueID + "/" + imgSlide.imagePath} />
                                    </div>

                                    <div className="DeleteItemDiv" >
                                        <button className="deleteButton" onClick={async () => {
                                            const UpdateResult = await SlideDelete(imgSlide.id)
                                                .then(async (result) => {

                                                    await ReloadSlide(selectedPageProps.id).then((rres) => {
                                                        myAlert.success("Resim Silindi")
                                                    }).catch((err) => { myAlert.error("İşlem Gerçekleşmedi " + err) })
                                                }).catch((err) => { myAlert.error("işleminiz sırasında hata oluştu " + err) })

                                        }} id={imgSlide.id} >Resmi Sil</button>
                                    </div>


                                </div>)
                        })
                    }
                </div>
                <div style={{ "height": "20px" }}></div>
                <div>
                    <div style={{ "color": "white", "width": "130px", "marginTop": "25%", "marginBottom": "10%", "marginLeft": "5%" }}>
                        Yeni Slide Ekle
                    </div>
                    <div><input style={{ "color": "white", "width": "100%" }} type={"file"} onChange={
                        async (e) => {

                            const UpdateResult = await SlideAdd(e.target.files[0], selectedPageProps.id, QIssueID, selectedPageProps.id)
                                .then(async (result) => {

                                    await ReloadSlide(selectedPageProps.id).then((rres) => {
                                        myAlert.success("Resim Eklendi")
                                    }).catch((err) => { myAlert.error("İşlem Gerçekleşmedi " + err) })
                                }).catch((err) => { myAlert.error("işleminiz sırasında hata oluştu " + err) })

                        }
                    } /></div></div>
                <div></div>
            </div>

            {/* Kutu1 */}



            {/* test */}

            {/* test */}



            <div id="gjs"
                style={{
                    "height": '1200px',
                    "overflow": "auto"


                }}
            />






        </>

    )
}

export default EditorTest;